import { Chevron } from "@components/icons"
import colors from "@constants/colors"
import {
  smallcapsBold14Styles,
  smallcapsRegular13Styles,
} from "@constants/typography"
import { Link } from "gatsby"
import React from "react"
import styled from "styled-components"

export const Headers = styled.div`
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  display: flex;
  height: 90px;
  padding: 0 20px;
  border-bottom: solid 1px ${colors.dividerLineGray};
`

const headerActionBaseProps = `
  ${smallcapsRegular13Styles}
  display: flex;
  height: 32px;
  padding: 3px 10px 0;
  align-items: center;
  color: ${colors.mediumGray};
  background-color: ${colors.dividerLineGray};
  border: none;
  border-radius: 2px;
  outline: none;
`

export const ActionButton = styled.button`
  ${headerActionBaseProps}
`

export const ActionLink = styled(Link)`
  ${headerActionBaseProps}
`

const BreadcrumbContainer = styled.button`
  display: flex;
  transform: translateX(-16px);
  background-color: transparent;
  border: none;
`

const BreadcrumbIcon = styled.div`
  width: 24px;
  height: 24px;
  margin-right: 6px;
  transform: rotate(180deg);
`

export const BreadcrumbText = styled.span`
  ${smallcapsBold14Styles};
  padding-top: 2px;
`

export const BreadcrumbButton: React.FC<{
  label: string
  onClick?: () => void
}> = ({ label, onClick }) => (
  <BreadcrumbContainer onClick={onClick}>
    <BreadcrumbIcon>
      <Chevron />
    </BreadcrumbIcon>
    <BreadcrumbText>{label}</BreadcrumbText>
  </BreadcrumbContainer>
)
